import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TechnicalSupportJobGuru = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Technical Support Jobs in Gurugram | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Explore the latest technical support jobs in Gurugram . Find openings for desktop support engineers, IT helpdesk staff, and technical support executives. Apply for fresher and experienced roles now!"
        />
        <meta
          name="keywords"
          content="technical support jobs in Gurugram, IT support jobs in Gurugram , desktop support jobs Gurugram, helpdesk jobs Gurugram, hardware engineer jobs Gurugram, tech support jobs Gurugram, customer support engineer Gurugram, IT support executive jobs Gurugram, fresher technical support jobs Gurugram"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/technicalsupport-jobs-in-gurugram"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Technical Support Jobs in Gurugram – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for <strong>technical support jobs in Gurugram </strong>? Find
          hundreds of opportunities in IT support, helpdesk management, network
          troubleshooting, and hardware maintenance. Whether you are a fresher
          or an experienced engineer, apply to top companies hiring now.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Technical Support Professionals
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>HCL Technologies</li>
          <li>Tech Mahindra</li>
          <li>Concentrix</li>
          <li>Wipro</li>
          <li>Infosys BPM</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Technical Support Job Roles in Gurugram
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Technical Support Executive Jobs in Gurugram</li>
          <li>Desktop Support Engineer Jobs in Gurugram</li>
          <li>IT Helpdesk Jobs in Gurugram NCR</li>
          <li>Customer Support Engineer Jobs in Gurugram</li>
          <li>Network Support Jobs in Gurugram</li>
          <li>Hardware & Software Support Jobs in Gurugram</li>
          <li>Technical Support Analyst Jobs in Gurugram</li>
          <li>Remote Technical Support Jobs in Gurugram</li>
          <li>Voice Process Technical Support Jobs in Gurugram</li>
          <li>Non-Voice Technical Support Jobs in Gurugram</li>
        </ul>

        <p className="text-gray-600">
          Begin your career with <strong>jobsindelhincr.in</strong> — your
          trusted platform to find verified{" "}
          <strong>technical support job openings</strong> in Gurugram . Apply
          directly to companies and start your IT support career today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default TechnicalSupportJobGuru;
